



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PemantauanPacuSvc from "@/services/PemantauanPacuService";
import { appModule } from "@/store/modules/app";

@Component
export default class MonitoringPacuInputModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) parentId!: number | null;
  @Prop({ default: null }) editData!: any;

  saving = false;
  form: any = this.blankForm();

  aldreteFields = [
    { key: "aldrete_kesadaran", label: "Kesadaran" },
    { key: "aldrete_tekanan_darah", label: "Tekanan Darah" },
    { key: "aldrete_pernafasan", label: "Pernafasan" },
    { key: "aldrete_aktivitas", label: "Aktifitas" },
    { key: "aldrete_warna_kulit", label: "Warna Kulit" },
  ];

  get dialog() { return this.value; }
  set dialog(v: boolean) { this.$emit("input", v); }

  get isEdit() { return !!this.editData; }

  get aldreteTotal(): number | null {
    const vals = this.aldreteFields.map(f => this.form[f.key]);
    if (!vals.some(v => v !== null && v !== undefined && v !== "")) return null;
    return vals.reduce((s: number, v: any) => s + (Number(v) || 0), 0);
  }

  get aldreteColor(): string {
    const t = this.aldreteTotal;
    if (t === null) return "grey";
    if (t >= 9) return "green";
    if (t >= 5) return "orange";
    return "red";
  }

  get canSave(): boolean {
    return !!this.form.pukul;
  }

  blankForm() {
    return {
      pukul: "",
      td_sistole: null,
      td_diastole: null,
      frekuensi_nadi: null,
      frekuensi_nafas: null,
      saturasi_o2: null,
      skor_nyeri_vas: null,
      aldrete_kesadaran: null,
      aldrete_tekanan_darah: null,
      aldrete_pernafasan: null,
      aldrete_aktivitas: null,
      aldrete_warna_kulit: null,
      bromage_skor: null,
      bromage_pergerakan_kaki: "",
    };
  }

  @Watch("value")
  onOpen(v: boolean) {
    if (v) {
      if (this.editData) {
        this.form = {
          ...this.blankForm(),
          ...this.editData,
          pukul: (this.editData.pukul || "").substring(0, 5),
        };
      } else {
        this.form = this.blankForm();
        const now = new Date();
        this.form.pukul = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      }
    }
  }

  cancel() {
    this.dialog = false;
  }

  async save() {
    if (!this.parentId) return;
    this.saving = true;
    try {
      const payload = { ...this.form };
      let resp;
      if (this.isEdit && this.editData?.id) {
        resp = await PemantauanPacuSvc.updateMonitoring(this.editData.id, payload);
      } else {
        resp = await PemantauanPacuSvc.addMonitoring(this.parentId, payload);
      }
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay(this.isEdit ? "Observasi diperbarui" : "Observasi ditambahkan");
        this.$emit("saved", resp.data.data);
        this.dialog = false;
      }
    } catch (e) {
      // handled by service
    }
    this.saving = false;
  }
}
